module.exports = __webpack_public_path__ + "static/img/cx-logo.4a955a9e.png";